/* eslint-disable import/no-anonymous-default-export */
import { exeRequest } from '../utils/APIUtils';

export default {
    signin: async (data) => {
        const resultat = await exeRequest("/login", "POST", data);
        return resultat;
    },

    getUserInfo: async () => (await exeRequest("/users/me", "GET")).data,

    getAdministrateurs: async () => await exeRequest("/admin/administrateurs", "GET"),

    getAdministrateurById: async (id) => exeRequest(`/admin/administrateurs/${id}`, "GET"),

    createAdmin: async (data) => exeRequest(`/admin/enregistrer-admin`, "POST", data),

    updateProfile: async (id, data) => exeRequest(`/admin/update-profile/${id}`, "PUT", data),

    deleteAdmin: async (id) => exeRequest(`/admin/administrateur/${id}`, "DELETE"),

    resetPassword: async (id) => exeRequest(`/admin/administrateur/${id}/reset-password`, "PATCH"),

    updateRolePermissions: async (id, data) => exeRequest(`/admin/update-role-permissions/${id}`, "PUT", data),

    getPermissions: async () => await exeRequest("/admin/permissions", "GET"),

    getRolePresets: async () => await exeRequest("/admin/role-presets", "GET"),

    changePassword: async (data) => exeRequest("/change-password", "POST", data),

    toggleActive: async (id) => exeRequest(`/admin/administrateur/${id}/toggle-active`, "PATCH"),
};
